// Custom Persian validation messages
const yupPersianValidationErrors = {
    mixed: {
        default: 'خطا در مقدار ورودی این مقدار',
        required: 'این مقدار الزامی است',
        oneOf: 'این مقدار باید یکی از مقادیر ${values} باشد',
        notOneOf: 'این مقدار نباید یکی از مقادیر ${values} باشد',
        notNull: 'این مقدار نباید خالی باشد',
        notType: 'نوع این مقدار باید ${type} باشد',
        defined: 'این مقدار باید تعریف شده باشد',
    },
    string: {
        length: 'این مقدار باید دقیقا ${length} کاراکتر باشد',
        min: 'این مقدار باید حداقل ${min} کاراکتر باشد',
        max: 'این مقدار باید حداکثر ${max} کاراکتر باشد',
        matches: 'این مقدار با الگوی مورد نظر مطابقت ندارد',
        email: 'لطفا یک ایمیل معتبر وارد کنید',
        url: 'لطفا یک آدرس معتبر وارد کنید',
        uuid: 'لطفا یک UUID معتبر وارد کنید',
        datetime: 'لطفا یک تاریخ و زمان معتبر وارد کنید',
        datetime_offset: 'لطفا یک تاریخ و زمان با منطقه زمانی معتبر وارد کنید',
        datetime_precision: 'لطفا یک تاریخ و زمان با دقت ${precision} وارد کنید',
        trim: 'این مقدار نباید دارای فاصله اضافی باشد',
        lowercase: 'این مقدار باید به حروف کوچک باشد',
        uppercase: 'این مقدار باید به حروف بزرگ باشد',
    },
    number: {
        min: 'این مقدار باید بزرگتر یا مساوی ${min} باشد',
        max: 'این مقدار باید کوچکتر یا مساوی ${max} باشد',
        lessThan: 'این مقدار باید کمتر از ${less} باشد',
        moreThan: 'این مقدار باید بیشتر از ${more} باشد',
        positive: 'این مقدار باید یک عدد مثبت باشد',
        negative: 'این مقدار باید یک عدد منفی باشد',
        integer: 'این مقدار باید یک عدد صحیح باشد',
    },
    date: {
        min: 'این مقدار باید بعد از تاریخ ${min} باشد',
        max: 'این مقدار باید قبل از تاریخ ${max} باشد',
    },
    object: {
        noUnknown: 'این مقدار شامل فیلدهای ناشناخته است',
    },
    array: {
        length: 'این مقدار باید دقیقا شامل ${length} مورد باشد',
        min: 'این مقدار باید حداقل شامل ${min} مورد باشد',
        max: 'این مقدار باید حداکثر شامل ${max} مورد باشد',
    },
    tuple: {
        notType: 'این مقدار باید یک تاپل معتبر باشد',
    },
    boolean: {
        isValue: 'این مقدار باید یک مقدار بولین معتبر باشد',
    },
};

export default yupPersianValidationErrors;